export interface ServiceWorkerConfig {
  enabled: boolean;
  cacheEnabled: boolean;
  cacheName: string;
  urlsToCache: string[];
  updateInterval: number;
  skipWaiting: boolean;
  clientsClaim: boolean;
}

const config: ServiceWorkerConfig = {
  enabled: process.env.NODE_ENV === 'production',
  cacheEnabled: process.env.NODE_ENV === 'production',
  cacheName: 'portal-v2',
  urlsToCache: [
    '/portal',
    '/portal/index.html',
    '/portal/manifest.json',
    '/portal/icons/favicon.ico',
    '/portal/icons/favicon.svg',
    '/portal/icons/apple-touch-icon.png',
    '/portal/icons/favicon-96x96.png',
    '/portal/icons/web-app-manifest-192x192.png',
    '/portal/icons/web-app-manifest-512x512.png'
  ],
  updateInterval: 60 * 60 * 1000, // 1 hour
  skipWaiting: true,
  clientsClaim: true
};

export default config; 